import React, { useState, useEffect } from 'react';
import { Input, Button, Card, Result, Spin } from 'antd';
import "./Lookup.css";
import QueueAnim from 'rc-queue-anim';
import RiskWarning from './RiskWarning';
function Lookup() {
    const [number, setNumber] = useState('');
    const [result, setResult] = useState(null);
    const [timestamp, setTimestamp] = useState(null);
    const [loading, setLoading] = useState(false);
    const [resultStatus, setResultStatus] = useState();
    const [checkTimes, setCheckTimes] = useState(0);
    const [resultMessage, setResultMessage] = useState();
    const [resultTitle, setResultTitle] = useState();
    useEffect(() => {
        
    })
    const handleInputChange = (e) => {
        setNumber(e.target.value);
    }

    
    const handleButtonClick = async(value) => {
        setResult(null);
        setTimestamp(null);
        setLoading(true);
        try {
            const response = await fetch(`http://check.harscorail.com.cn:8086/code/${number}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            if (data["serialCode"] != "0000000000000000") {
                setResult(true);
                const originalTimestamp = data["lastQueryTime"];
                const adjustedTimestamp = new Date(originalTimestamp).getTime();
                const adjustedDate = new Date(adjustedTimestamp).toLocaleString();
                setTimestamp(adjustedDate);
                setCheckTimes(data["checkTimes"]);
                if(checkTimes == 0) {
                    setResultStatus("success");
                    setResultTitle("查询成功")
                    setResultMessage("您所查询的序列码存在，这是第一次查询")
                }
                else{
                    setResultStatus("warning")
                    setResultTitle("风险提示")
                }
                
            } else {
                setResult(false);
                setResultMessage("您所查询的序列码不存在")
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
        
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleButtonClick();
        }
    };

    useEffect(() => {
        if(result && checkTimes >= 1) {
            setResultStatus("warning")
            setResultTitle("风险提示")
            const resultMessage =(<>
                您所查询的序列码存在, 这是第<strong>{checkTimes + 1}</strong>次查询, 上次查询时间 <strong>{timestamp}</strong><br />
                该序列码已经被多次查询，请注意甄别风险
            </>);
            setResultMessage(resultMessage)
        }
        else if(result && checkTimes === 0) {
            setResultStatus("success")
            setResultTitle("查询成功")
            const resultMessage =(<>
                您所查询的序列码存在, 这是第<strong>{checkTimes + 1}</strong>次查询<br />
                该序列码是第一次查询，请放心使用
            </>);
        }
        else if(!result) {
            setResultTitle("查询失败")
            setResultStatus("error")
        }
        
    }, [checkTimes, result])
    return (
        <div className="container">
            
            <Card title={<div className="card-title">产品防伪查询</div>} className="lookup-card"
            style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
            >
                <Input 
                    placeholder="请输入序列码" 
                    value={number} 
                    onChange={handleInputChange} 
                    onKeyPress={handleKeyPress}
                    className="input"
                />
                <div className="button-container">
                    <Button 
                        type="primary" 
                        onClick={handleButtonClick} 
                        className="button"
                        style={{ fontFamily: 'Arial, sans-serif', fontSize: '16px', fontWeight: 'regular' }}
                    >
                        查询
                    </Button>
                </div>  
                {loading ? (
                    <div className="loading-container">
                        <Spin size="large" />
                    </div>
                ) : (
                    <QueueAnim delay={200} className="queue-simple">
                        {result !== null && (
                            <div>
                                <Result
                                    status={resultStatus}
                                    title={resultTitle}
                                    subTitle={resultMessage}
                                />
                            </div>
                        )}
                    </QueueAnim>
                )}
                
            </Card>
            <QueueAnim delay={200} className="queue-simple">
            {result != null && <RiskWarning />}
            </QueueAnim>
        </div>
    );
}


export default Lookup;